import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchESignReasonTypes = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/ecrf/get_e_sign_reason/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

export const useGetESignReasonTypes = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["e_sign_reason_types"],
    queryFn: fetchESignReasonTypes,
    enabled,
  });
};

export default useGetESignReasonTypes;
